import { useEffect, useRef, useState } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { faCopy, faEye, faMoneyCheckDollar, faPaperPlane, faPrint, faXmark } from "@fortawesome/free-solid-svg-icons";
import { BuyInvoiceApi, BuyInvoiceDataType } from "@/api/BuyInvoiceApi";
import { formatMoneyValue } from "@utils/Currency";
import { showAlert } from "@utils/Alert";
import styles from "./style.module.scss";
import moment from "moment";
import { useAppSelector } from "@/store/hooks";
import LoadingScreen from "@components/content/LoadingScreen";
import { renderEDocumentStatusOffCanvasTrigger } from "@utils/ModelIndexUtils";
import { ProviderApi } from "@/api/ProviderApi";
import { EasyposEInvoice } from "@/atv/submitInvoice";
import { generateCreditFromBuyInvoice, generateCreditFromInvoice, getFechaDeEmisionRFC3339, isValidEDocument, sendEBuyInvoiceData, sendECreditnoteData } from "@utils/EDocument";
import { EDOCUMENT_SUBMITION_STATUS_CODE, EDOCUMENT_SUBMITION_STATUS_SENT, InfoRefElement } from "@/atv/eInvoiceApi";
import { BuyInvoiceType } from "@utils/Constants";
import { CreditnoteApi } from "@/api/CreditnoteApi";
import { CreditnoteProductDataType } from "@/api/CreditnoteProductApi";
import { BuyInvoiceFormDataKeys } from "@/generated/BuyInvoiceFormDataKeys";
import { buyInvoiceRelatedAttributes } from "@/formTypes/BuyInvoiceDataType";

type BuyInvoiceIndexProps = {
  buyInvoiceType: BuyInvoiceType
}

const BuyInvoiceIndex = (props: BuyInvoiceIndexProps) => {
  const { buyInvoiceType } = props;
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);
  const suscriptionData = useAppSelector(state => state.suscription.suscription)
  const [easyposEBuyInvoice, setEasyposEBuyInvoice] = useState<EasyposEInvoice>()
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [providers, setProviders] = useState<Record<string, string>>({});

  useEffect(() => {
    if (suscriptionData) {
      setEasyposEBuyInvoice(new EasyposEInvoice(suscriptionData))
    }
    loadProviders()
  }, [suscriptionData]);

  const loadProviders = async () => {
    const providers = await ProviderApi.optionsList()
    setProviders(providers)
  }

  const resendEBuyInvoice = async (invoiceId: string) => {
    setIsLoading(true);
    try {
      if (easyposEBuyInvoice) {
        const response = await sendEBuyInvoiceData(easyposEBuyInvoice, invoiceId)
        if (response.status == EDOCUMENT_SUBMITION_STATUS_CODE[EDOCUMENT_SUBMITION_STATUS_SENT]) {
          showAlert("success", "La factura eletronica de compra ha sido reenviada correctamente, el estado de la factura se actualizara una vez Tributacion de una respuesta sobre la Factura de compra")
        } else {
          showAlert("danger", "La factura electronicade compra no ha sido reenviada correctamente")
        }
      } else {
        showAlert("danger", "No fue possible enviar el document a hacienda ")
      }
    } finally {
      setIsLoading(false)
    }
  }

  const triggerPrintBuyInvoice = (item: BuyInvoiceDataType) => {
    window.open(`/user/buyInvoices/print/${item.id}`)
  }

  const cancelBuyInvoice = async (id: string) => {
    try {
      setIsLoading(true)
      const buyInvoice = await BuyInvoiceApi.get(id, {
        selectionSet: [
          ...BuyInvoiceFormDataKeys.filter(k => !buyInvoiceRelatedAttributes.includes(k)),
          "currency.*",
          "buyInvoiceProducts.*",
        ]
      })
      const isRejected = !isValidEDocument(`${buyInvoice.edocument_status_payload}`)
      let additionaMessage = "";
      if (!isRejected) {
        //TODO Revisar este proceso de cancelacion
        // const { creditnote, products } = generateCreditFromBuyInvoice(buyInvoice, `Anulacion de Factura Electronica de compra #${buyInvoice.numero}`)
        // const createdCreditnote = await CreditnoteApi.createCreditnoteAndProducts(creditnote, products as CreditnoteProductDataType[], false)

        // if (easyposEBuyInvoice && suscriptionData?.einvoice_status) {
        //   const fechaEmisionUTC = getFechaDeEmisionRFC3339(createdCreditnote, "created")
        //   const referencesList = Array<InfoRefElement>();
        //   const referencia = easyposEBuyInvoice.crearInformacionRefencia(fechaEmisionUTC, "notaCreditoFacturaElectronicaCompra", `${createdCreditnote.description}`, "anular", `${buyInvoice.invoice_key}`)
        //   referencesList.push(referencia)
        //   await sendECreditnoteData(easyposEBuyInvoice, `${createdCreditnote.id}`, referencesList, "BuyInvoice")
        // }
        // additionaMessage = `. Se ha creado la nota de credito #${createdCreditnote.numero} para anular este documento electronico`
      }

      await BuyInvoiceApi.update(id, {
        anulada: true,
        buyInvoiceType: buyInvoice.buyInvoiceType,
        status: "anulada",
        providerId: buyInvoice.providerId
      })
      showAlert("success", `Factura Electronica de compra anulada correctamente${additionaMessage}`)
      modelRef.current?.refetch()
    } catch (err) {
      showAlert("danger", "No fue possible anular la factura de compra")
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <PageContainer
      title={`Lista Factura De Compras ${buyInvoiceType == "Expense" ? "de Gastos" : ""}`}
      backUrl="/user/dashboard-accounting"
      primaryActions={[
        {
          onClick: () => {
            navigate(`/user/buyInvoice${buyInvoiceType == "Expense" ? "Expenses" : "s"}/add`)
          },
          actionTitle: "Nuevo",
          color: "success"
        }
      ]}
    >
      <ModelIndex<BuyInvoiceDataType>
        fetchData={(...args) => BuyInvoiceApi.fetchAll(...args)}
        ref={modelRef}
        messages={{
          noResults: "No hay Facturas de Compras creadas aun"
        }}
        meiliConfig={{
          index: "buyinvoices",
          filter: `buyInvoiceType = ${buyInvoiceType}`,
          sort: ["fecha:desc"]
        }}
        filterProps={[
          {
            key: "sequence",
            filterType: "eq"
          },
          {
            key: "nombre_factura",
            filterType: "contains"
          }
        ]}
        primaryProperties={[
          {
            key: "sequence",
            highlighted: true,
            className: styles.sequence,
            optionalHighlighted: (val: any, data: BuyInvoiceDataType) => { return data.anulada || false },
            highlightedColors: {
              "true": {
                "bg": "#dc3545",
                "text": "#fff"
              },
              "false": {
                "bg": "#337ab7",
                "text": "#fff"
              }
            },
          },
          {
            key: (d) => d.nombre_factura || (d && providers[d.providerId || ""] || ""),
            alignment: "Start"
          },
        ]}
        primaryPropertiesSizing={
          [
            { sm: "4", xs: "12" },
            { sm: "8", xs: "12" }
          ]
        }
        secondaryProperties={[
          {
            key: (data) => {
              const date = moment(data.fecha, "YYYY-MM-DD")
              return date.format("DD-MM-YYYY")
            },
            title: "Fecha",
          },
          {
            key: (data) => renderEDocumentStatusOffCanvasTrigger(data, { model: "BuyInvoice", id: `${data.id}` }),
            title: "Estado ATV"
          },
          {
            key: (data) => {
              if ("currency_id" in data) {
                return formatMoneyValue(data.total, (data as any).currency_id)
              }
              return formatMoneyValue(data.total, data.currency.currency_id)
            },
            title: "Total",
            highlighted: true
          }
        ]}
        secondaryPropertiesSizing={
          [
            { sm: "4", md: "2" },
            { sm: "4", md: "3" },
            { sm: "4", md: "2" }
          ]
        }
        listActions={[
          {
            isVisible: (data) => !data.edocument_status_payload,
            onClick: (id) => resendEBuyInvoice(id),
            actionTitle: "Reenviar Factura al ATV",
            iconProps: { icon: faPaperPlane }
          },
          {
            isVisible: (data) => !data.anulada && !!data.edocument_status_payload,
            actionTitle: "Anular Factura de Compra",
            iconProps: { icon: faXmark },
            needConfirm: true,
            confirmProps: {
              title: "Anular Factura de Compra",
              confirmMessage: "¿Seguro que desea anular esta Factura de Compra?",
              confirmBtnText: "Anular"
            },
            onClick: (id: string) => { cancelBuyInvoice(id) }
          },
          {
            href: "/user/buyInvoices/payments/{:id}",
            actionTitle: "Abonos de Facturas",
            iconProps: { icon: faMoneyCheckDollar }
          },
          {
            href: "/user/buyInvoices/copy/{:id}",
            actionTitle: "Copiar de Facturas de compra",
            iconProps: { icon: faCopy }
          },
          {
            href: "/user/buyInvoices/view/{:id}",
            actionTitle: "Ver Factura",
            target: "_blank",
            iconProps: { icon: faEye }
          },
          {
            onClick: (id, item) => triggerPrintBuyInvoice(item),
            actionTitle: "Imprimir Factura de compra",
            target: "_blank",
            iconProps: { icon: faPrint }
          }
        ]}
      >
      </ModelIndex>
      <LoadingScreen isLoading={isLoading} />
    </PageContainer >
  );
}

export default BuyInvoiceIndex;
